/**
 * @ngdoc services
 * @memberof mercury.modules.stock
 * @name StockBrands
 * @description Data access service for managing Stock Brands
 */
angular.module('mercury.modules.stock.brand')
.factory('StockBrands', ["$resource", "settings", function($resource, settings) {
  var StockBrands = $resource(settings.apiHost + '/r/StockBrands');

  /**
   * Get all active stock brands
   *
   * @memberof StockBrands
   */
  function getAllActive() {
    return StockBrands.query({$filter: 'DatestampDeleted eq null'});
  }

  /**
   * Create a custom stock brand
   *
   * @memberof StockBrands
   * @param  {Object} newBrand New stock brand model
   */
  function create(newBrand) {
    return StockBrands.save(newBrand).$promise;
  }

  return {
    getAllActive: getAllActive,
    create: create
  };
}]);
